import { render, staticRenderFns } from "./AgentStatusPending.vue?vue&type=template&id=f1c8d924&scoped=true"
import script from "./AgentStatusPending.vue?vue&type=script&lang=js"
export * from "./AgentStatusPending.vue?vue&type=script&lang=js"
import style0 from "./AgentStatusPending.vue?vue&type=style&index=0&id=f1c8d924&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1c8d924",
  null
  
)

export default component.exports